/**
 * Umami Analytics Plugin
 * Loads Umami script dynamically based on environment configuration
 */
export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()
    const umamiUrl = config.public.umamiUrl
    const umamiWebsiteId = config.public.umamiWebsiteId

    // Only load if URL and Website ID are configured
    if (!umamiUrl || !umamiWebsiteId) {
        console.warn('[Umami] Not configured - umamiUrl or umamiWebsiteId missing')
        return
    }

    // Create and inject the Umami script
    const script = document.createElement('script')
    script.src = `${umamiUrl}/script.js`
    script.defer = true
    script.setAttribute('data-website-id', umamiWebsiteId)
    document.head.appendChild(script)
})
